// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__2TRcS","employee-header__buttons":"Header_employee-header__buttons__2oYLh","employee-header-item":"Header_employee-header-item__maRj9"};